import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveImmobilization } from '../../procedures/immobilization/store/immobilization.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setImmobilizationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addImmobilizationToTimeline } = quickActionsObject
  if (addImmobilizationToTimeline) {
    yield put(saveImmobilization())
  }
}

export function* setImmobilizationQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_IMMOBILIZATION_TO_TIMELINE], setImmobilizationQuickActionTimeLineRow)
}
